function IconTalkTimeHighBubbles() {
  return (
    <svg
      width="153"
      height="79"
      viewBox="0 0 153 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M48.2344 51.4375C48.2344 40.7188 37.8219 32.2969 24.5 32.2969C11.1781 32.2969 0.765625 40.7188 0.765625 51.4375C0.765625 62.2328 11.4078 70.9609 24.5 70.9609C26.6437 70.9609 28.7875 70.7312 30.8547 70.1953L42.5687 75.0187C42.6453 75.1719 42.7984 75.1719 42.875 75.1719C43.0281 75.1719 43.1812 75.0953 43.3344 75.0187C43.5641 74.8656 43.6406 74.6359 43.6406 74.3297L42.875 63.7641C46.3203 60.3187 48.2344 55.9547 48.2344 51.4375Z"
          fill="white"
        />
      </g>
      <g opacity="0.5">
        <path
          d="M111.531 59.875C111.531 52.4375 118.756 46.5938 128 46.5938C137.244 46.5938 144.469 52.4375 144.469 59.875C144.469 67.3656 137.084 73.4219 128 73.4219C126.513 73.4219 125.025 73.2625 123.591 72.8906L115.463 76.2375C115.409 76.3437 115.303 76.3438 115.25 76.3438C115.144 76.3438 115.038 76.2906 114.931 76.2375C114.772 76.1312 114.719 75.9719 114.719 75.7594L115.25 68.4281C112.859 66.0375 111.531 63.0094 111.531 59.875Z"
          fill="white"
        />
      </g>
      <g opacity="0.5">
        <path
          d="M106.428 29.657C103.71 40.669 91.5504 49 77.0004 49C74.6643 48.9977 72.3336 48.7747 70.0394 48.334L69.9004 48.4C73.7614 53.637 81.0364 57 89.0004 57C91.2585 57.0001 93.5083 56.7261 95.7004 56.184L103.49 60.858C103.645 60.9497 103.821 60.9988 104 61C104.266 61 104.52 60.8946 104.707 60.7071C104.895 60.5196 105 60.2652 105 60V51.669C108.874 48.5 111 44.375 111 40C110.967 38.0581 110.545 36.1426 109.76 34.3662C108.975 32.5899 107.842 30.9887 106.428 29.657V29.657Z"
          fill="white"
        />
        <path
          d="M56 53C55.7348 53 55.4804 52.8946 55.2929 52.7071C55.1054 52.5196 55 52.2652 55 52V38.6C53.1497 36.8429 51.6666 34.736 50.6367 32.4015C49.6068 30.0669 49.0504 27.5511 49 25C49 12.869 61.561 3 77 3C92.439 3 105 12.869 105 25C105 37.131 92.439 47 77 47C74.5665 46.9972 72.1398 46.7418 69.759 46.238L56.447 52.9C56.3077 52.9675 56.1547 53.0017 56 53V53Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export { IconTalkTimeHighBubbles };
